"use strict";

exports.__esModule = true;
exports.createAMPHashtagHref = exports.createHashtagHref = exports.createHashtagPath = exports.decodeQuery = exports.encodeQuery = void 0;

var _lodash = require("lodash");

var _getOuterUrl = _interopRequireDefault(require("./get-outer-url"));

var _uri = require("../../services/uri");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var encodeQuery = function encodeQuery(query) {
  return encodeURIComponent(query.toLowerCase().replace(/#/g, '.hash.'));
};

exports.encodeQuery = encodeQuery;

var decodeQuery = function decodeQuery(query) {
  return decodeURIComponent(query).replace(/\.hash\./g, '#');
};

exports.decodeQuery = decodeQuery;

var createHashtagPath = function createHashtagPath(decoratedText) {
  var hashtag = "#" + (0, _lodash.trimStart)(decoratedText, '#');
  return (0, _uri.readableUrl)("/search/" + encodeQuery(hashtag));
};

exports.createHashtagPath = createHashtagPath;

var createHashtagHref = function createHashtagHref(decoratedText, sectionUrl) {
  return (0, _getOuterUrl["default"])(createHashtagPath(decoratedText), sectionUrl);
};

exports.createHashtagHref = createHashtagHref;

var createAMPHashtagHref = function createAMPHashtagHref(sectionUrl) {
  return function (decoratedText) {
    return (0, _getOuterUrl["default"])(createHashtagPath(decoratedText), sectionUrl);
  };
};

exports.createAMPHashtagHref = createAMPHashtagHref;